//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { encrypt } from "@/assets/utils/cryptoUtil";
import { getHealthCardList } from "@/api/module";
export default {
  name: "index",
  data: function data() {
    return {
      active: 0,
      dataList: []
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      var physicalNo = this.$encruption(JSON.parse(localStorage.getItem("loginuser")).physicalno);
      var encodedPhysicalNo = encodeURIComponent(physicalNo);
      var param = {
        physicalNo: encodedPhysicalNo
      }; // console.log(param)

      getHealthCardList(param).then(function (res) {
        if (res.code == 200) {
          _this.dataList = res.data;
        }
      });
    },
    toHome: function toHome() {
      this.$router.push({
        name: 'home'
      });
    },
    toUserinfo: function toUserinfo() {
      this.$router.push({
        name: 'userinfo'
      });
    },
    toCardInfo: function toCardInfo(item) {
      this.$router.push({
        name: 'healthCertificateInfo',
        query: {
          SerialNo: item.serialNo
        }
      });
    }
  }
};